import { Component, Context, ContextType, PropsWithChildren } from 'react';

import utils from '../utils';

import { LegacyContext } from './LegacyContextType';
import { AuthContext } from './Router';

export default class Authenticated extends Component<PropsWithChildren<any>, Record<string, never>> {
  static contextType: Context<LegacyContext> = AuthContext;
  context!: ContextType<typeof AuthContext>;

  render() {
    const { user } = this.context;
    const { children } = this.props;

    const authenticated = !!user;

    const propsToForward = utils.excludeProps(['inGroup'], this.props);

    return authenticated ? utils.enforceRootElement(children, propsToForward) : null;
  }
}
